import schema from './schemaVersions/v49.js';
	const finalSchema = { wip: false, ...schema };
	export default finalSchema;